import _ from "lodash";
import * as cf from "../../app/core/cf";
import { Screen } from "../../app/core/screen";
import { PresetDateRangeDropDownList } from "../../app/core/ui";
import * as z from "../../framework";
import { SimpleScreen } from "../controls/simpleScreen";
import { bind, observable } from "../core/kendo";
import { ll } from "../core/ll";
import { user, UserDefinedField } from "../core/user";
import { codes } from "../data/codes";
import * as filter from "../data/filter";
import * as schema from "../data/schema";
import view from "./gridFilterMenu.view";
import { allowNullFilters } from "./gridUtil";

export var GridFilterMenu = function (args) {
    var me = this;

    me.menu = args.menu;
    me.column = args.column;
    me.gridId = args.gridId;
    me.field = args.field;
    me.mainEntityType = args.mainEntityType;
    me.userDefinedListId =
        (args.column && args.column.UserDefinedListId) || null;
    me.menuContainer = args.menuContainer;
    me.customFilterMenu = args.customFilterMenu;
};

GridFilterMenu.prototype = {
    create: function () {
        var me = this;

        if (!me.column) {
            return;
        }

        // If the column is a UDF field, then skip checking against the schema.
        if (
            me.column.UserDefinedListId == null &&
            !me.column.isUDFLV &&
            !me.column.isUDF &&
            !me.column.type
        ) {
            // See if we can get the schema info (if not its probably a hacked together and we dont want to use the custom grid filter menu)
            try {
                schema.getPropertyInfo({
                    entityName: me.mainEntityType,
                    path: me.field
                });
            } catch (e) {
                return false;
            }
        }

        if (me.column.type) {
            me.type = me.column.type;
        } else if (me.column.isCode) {
            me.type = "Code";
            me.codeId = me.column.codeFieldIdName || me.column.codeSelectPath;
            me.code =
                me.column.codeName ||
                schema.getPropertyInfo({
                    entityName: me.mainEntityType,
                    path: me.field
                }).entityName;
        } else if (me.column.UserDefinedListId != null || me.column.isUDFLV) {
            me.type = "UDFEnum";
            if (!me.column.UserDefinedListId) {
                // New Grid Code
                me.userDefinedListId = me._getUserDefinedListId(
                    me.column.codeSelectPath
                );
                me.udfField = me.column.codeSelectPath;
            } else {
                // Old Grid Code
                me.udfField = me.column.field;
            }
            me.userDefinedList = cf.getCustomFieldList(me.userDefinedListId);
        } else if (me.customFilterMenu) {
            me.type = "Custom";
        } else {
            var schemaPropertyInfo = schema.getPropertyInfo({
                entityName: me.mainEntityType,
                path: me.field
            });

            if (!me.type) {
                me.type =
                    schemaPropertyInfo.property &&
                    schemaPropertyInfo.property.Type;
            }

            if (
                z.codes[schemaPropertyInfo.entityName] &&
                (schemaPropertyInfo.propertyName === "CodeNumber" ||
                    schemaPropertyInfo.propertyName === "Value")
            ) {
                var split = schema.splitLast(schemaPropertyInfo.expandPath);
                var navigationPropertyInfo = schema.getNavigationPropertyInfo({
                    path: schemaPropertyInfo.fullExpandPath
                });

                me.type = "Code";
                me.code = schemaPropertyInfo.entityName;
                me.codeId = `${split[0] ? `${split[0]}/` : ""}${
                    navigationPropertyInfo.navigationProperty.MapTo
                }`;
            }
        }

        if (!me._isTypeSupported()) {
            const filterMenu = $(me.menu.element).find(".k-filter-menu");

            _.forEach(
                filterMenu.find(
                    `[data-role="dropdownlist"]:not(.k-filter-and)`
                ),
                element => {
                    const dropDownList = $(element).data("kendoDropDownList");

                    if (allowNullFilters(me.mainEntityType, me.field)) {
                        dropDownList.bind("change", () => {
                            const value = dropDownList.value(),
                                textBox = dropDownList.element
                                    .closest(".k-dropdown")
                                    .next();

                            if (
                                value === "isnull" ||
                                value === "isnotnull" ||
                                value === "isempty" ||
                                value === "isnotempty"
                            ) {
                                textBox.hide();
                            } else {
                                textBox.show();
                            }
                        });
                    } else {
                        const data = dropDownList.dataSource
                            .data()
                            .filter(
                                (e: any) =>
                                    e.value !== "isnull" &&
                                    e.value !== "isnotnull" &&
                                    e.value !== "isempty" &&
                                    e.value !== "isnotempty"
                            );
                        dropDownList.dataSource.data(data);
                    }
                }
            );

            return false;
        }

        // Remove existing filter menu
        me.menu.remove($(me.menu.element).find(".k-filter-item"));

        var screen = new ((Screen as any) || SimpleScreen)();
        $.extend(this, screen);

        me.formId = `${this.id}_FilterForm`;
        me.observable = observable({});
        me.closeMenu = false;

        $(me.menu.element).append(`
            <li class="k-item k-filter-item k-state-default k-last custom-filter-menu" aria-haspopup="true" role="menuitem" style="z-index: auto;">
                <span class="k-link"><span class="k-icon k-i-filter"></span>Apply filter<span class="k-icon k-i-arrow-60-right k-menu-expand-arrow"></span></span>
                <div class="k-animation-container" style="width: 161px; height: 447px; overflow: hidden; display: none; position: absolute; z-index: 10002; top: 0px; left: 160px;" aria-hidden="true">
                    <ul class="k-group k-menu-group k-popup k-reset" role="menu" data-role="popup" aria-hidden="true" style="display: none; position: absolute; font-size: 12px; font-family: &quot;Segoe UI&quot;, &quot;Trebuchet MS&quot;, Tahoma, Verdana, Arial, sans-serif; font-stretch: 100%; font-style: normal; font-weight: 400; line-height: normal; transform: translateX(-264px);">
                        <li>
                            <div class="k-filterable k-content" tabindex="-1" data-role="filtermenu">
                                <form id="${me.formId}" title="Filter Results" class="k-filter-menu custom-filter"></form>
                            </div>
                        </li>
                    </ul>
                </div>
            </li>
        `);

        var gridFilterMenuLayout = view(me.type);
        gridFilterMenuLayout.options.zScreen = me;
        gridFilterMenuLayout.render(
            $(me.menu.element).find(".k-filterable .k-filter-menu")
        );

        me.get("#FilterResults").text(ll("FilterableInfo"));
        me._showProperInputs();
        me._bindEvents();

        var grid = $(`#${me.gridId}`).data("kendoGrid");
        _.forEach(grid.columns as any[], column => {
            if (column.field == me.field && column.zFiltered) {
                column.zHeaderElement.addClass("k-state-active");
                return false;
            }
        });

        return true;
    },
    clearAllInputs: function () {
        var me = this;

        if (me.type === "Date" || me.type === "DateTime") {
            me.get("#PresetDateRanges").data("kendoDropDownList").select(0);
        }

        if (me.type === "DateTime") {
            me.get("#StartDateTime").data("kendoDateTimePicker").value("");
            me.get("#EndDateTime").data("kendoDateTimePicker").value("");
        }

        if (me.type === "Date") {
            me.get("#StartDate").data("kendoDatePicker").value("");
            me.get("#EndDate").data("kendoDatePicker").value("");
        }

        if (me.type === "TimeOfDay") {
            me.get("#TimeOfDayStartTime").data("kendoTimePicker").value("");
            me.get("#TimeOfDayEndTime").data("kendoTimePicker").value("");
        }

        if (me.type === "OffsetTime") {
            me.get("#OffsetStartTime").data("kendoTimePicker").value("");
            me.get("#OffsetEndTime").data("kendoTimePicker").value("");
        }

        if (
            me.type === "Date" ||
            me.type === "DateTime" ||
            me.type === "TimeOfDay" ||
            me.type === "OffsetTime"
        ) {
            me.get("#FirstExpression").data("kendoDropDownList").select(2);
            me.get("#SecondExpression").data("kendoDropDownList").select(2);
        }

        if (me.type === "Code") {
            me.get("#FirstCode").data("kendoComboBox").value("");
            me.get("#SecondCode").data("kendoComboBox").value("");
            me.get("#FirstCodeText").val("");
            me.get("#SecondCodeText").val("");
            me.get("#FirstExpression").data("kendoDropDownList").select(0);
            me.get("#SecondExpression").data("kendoDropDownList").select(0);
        }

        if (
            me.type === "Int32" ||
            me.type === "Int16" ||
            me.type === "Byte" ||
            me.type === "Currency" ||
            me.type === "Decimal" ||
            me.type === "Single"
        ) {
            me.get("#FirstNumber").data("kendoNumericTextBox").value(null);
            me.get("#SecondNumber").data("kendoNumericTextBox").value(null);
            me.get("#FirstExpression").data("kendoDropDownList").select(2);
            me.get("#SecondExpression").data("kendoDropDownList").select(2);
        }

        if (me.type === "Boolean") {
            me.get("#FirstExpression").data("kendoDropDownList").select(0);
            me.observable.set("FirstExpression", "istrue");
        }

        if (me.type === "Custom") {
            me.observable.set("FirstCustom", undefined);
            me.observable.set("SecondCustom", undefined);
            me.observable.set("FirstCustomText", undefined);
            me.observable.set("SecondCustomText", undefined);
        }
    },
    _bindEvents: function () {
        var me = this;

        me.get("#FilterForm").submit(function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
        });

        me.get("#ApplyFilter").click(function () {
            $.wait(10).then(function () {
                me._resetGridFilters();
                me._buildAndApplyFilterToGrid();
                me._closeFilterMenu();
            });
        });

        me.get("#ClearFilter").click(function () {
            $.wait(10).then(function () {
                me.clearAllInputs();
                me._resetGridFilters();
                me._closeFilterMenu();
            });
        });

        var firstExpression: kendo.ui.DropDownList = me
                .get("#FirstExpression")
                .data("kendoDropDownList"),
            secondExpression: kendo.ui.DropDownList = me
                .get("#SecondExpression")
                .data("kendoDropDownList"),
            hideOrShowValue = (expression: 1 | 2) => {
                if (expression === 2 && !secondExpression) {
                    return;
                }

                var value = (
                    expression === 1 ? firstExpression : secondExpression
                ).value();
                var valueElements = firstExpression.element
                    .closest(".expression")
                    .siblings(
                        expression === 1 ? ".first-value" : ".second-value"
                    );

                if (value === "isnull" || value === "isnotnull") {
                    valueElements.addClass("hidden");
                } else {
                    valueElements.removeClass("hidden");
                }
            };

        if (me.type === "Date" || me.type === "DateTime") {
            let presetDateRangeDropDownList = me
                .get("#PresetDateRanges")
                .data("me") as PresetDateRangeDropDownList;
            presetDateRangeDropDownList.build(me.type);
            presetDateRangeDropDownList.onChange((startTime, endTime) => {
                const startField = `StartDate${
                    me.type == "DateTime" ? "Time" : ""
                }`;
                const endField = `EndDate${
                    me.type == "DateTime" ? "Time" : ""
                }`;

                me.observable.set("FirstExpression", "gte");
                me.observable.set("Operator", "AND");
                me.observable.set("SecondExpression", "lte");
                me.observable.set(startField, startTime);
                me.observable.set(endField, endTime);
            });
        }

        me.menu.bind("deactivate", function (e) {
            // Stupid work around because I couldnt figure out how to close both the sub menu and root menu
            if (
                $(e.item[0]).is(
                    $(`#${me.formId}`).closest('[role="menuitem"]')
                ) &&
                me.closeMenu
            ) {
                $(me.menu.element)
                    .find(".k-state-active")
                    .removeClass("k-state-active");
                me.menuContainer.data("kendoMenu").element.parent().hide();
                me.menuContainer
                    .data("kendoMenu")
                    .element.parents(".k-animation-container")
                    .hide();
                me.closeMenu = false;
            }
        });

        me._setComboBoxInitialDataSources();

        bind({
            container: $(`#${me.formId}`),
            bind: ".bind-value",
            data: me.observable
        });

        hideOrShowValue(1);
        hideOrShowValue(2);

        firstExpression.bind("change", () => {
            hideOrShowValue(1);
        });

        if (secondExpression) {
            secondExpression.bind("change", () => {
                hideOrShowValue(2);
            });
        }

        if (me.column.isCode) {
            me._switchToCorrectInput(
                me.observable.FirstExpression,
                me.get("#FirstCode"),
                me.get("#FirstCodeText")
            );
            me._switchToCorrectInput(
                me.observable.SecondExpression,
                me.get("#SecondCode"),
                me.get("#SecondCodeText")
            );
        }

        if (me.column.customFilterMenu) {
            me._switchToCorrectInput(
                me.observable.FirstExpression,
                me.get("#FirstCustom"),
                me.get("#FirstCustomText")
            );
            me._switchToCorrectInput(
                me.observable.SecondExpression,
                me.get("#SecondCustom"),
                me.get("#SecondCustomText")
            );
        }
    },
    _switchToCorrectInput: function (val, comboInput, textInput) {
        switch (val) {
            case "eq":
            case "neq":
                comboInput.closest(".pane-field").show();
                textInput.closest(".pane-field").hide();
                break;
            case "startswith":
            case "contains":
            case "doesnotcontain":
            case "endswith":
                comboInput.closest(".pane-field").hide();
                textInput.closest(".pane-field").show();
        }
    },
    _showProperInputs: function () {
        var me = this;

        let values = me._getFiltersByField(
            me.field,
            $(`#${me.gridId}`).data("kendoGrid").dataSource.filter()
        );
        if (me.codeId) {
            let moreValues = me._getFiltersByField(
                me.codeId,
                $(`#${me.gridId}`).data("kendoGrid").dataSource.filter()
            );

            if (moreValues.firstValue && !values.firstValue) {
                values.operator = moreValues.operator;
                values.firstExpression = moreValues.firstExpression;
                values.firstValue = moreValues.firstValue;
            } else if (moreValues.firstValue && values.firstValue) {
                values.operator = moreValues.operator;
                values.secondExpression = moreValues.secondExpression;
                values.secondValue = moreValues.secondValue;
            }

            if (moreValues.secondValue) {
                values.operator = moreValues.operator;
                values.secondExpression = moreValues.secondExpression;
                values.secondValue = moreValues.secondValue;
            }
        }

        let filterObserveable = {
            FirstExpression: values.firstExpression,
            Operator: values.operator,
            SecondExpression: values.secondExpression
        } as any;

        if (me.type === "DateTime") {
            filterObserveable.StartDateTime = values.firstValue;
            filterObserveable.EndDateTime = values.secondValue;
        } else if (me.type === "Date") {
            filterObserveable.StartDate = values.firstValue;
            filterObserveable.EndDate = values.secondValue;
        } else if (me.type === "OffsetTime") {
            filterObserveable.OffsetStartTime = values.firstValue;
            filterObserveable.OffsetEndTime = values.secondValue;
        } else if (me.type === "TimeOfDay") {
            filterObserveable.TimeOfDayStartTime = values.firstValue;
            filterObserveable.TimeOfDayEndTime = values.secondValue;
        } else if (me.type === "Code" || me.type === "UDFEnum") {
            filterObserveable.FirstCode = values.firstValue;
            filterObserveable.SecondCode = values.secondValue;
            filterObserveable.FirstCodeText = values.firstValue;
            filterObserveable.SecondCodeText = values.secondValue;
        } else if (me.type === "Boolean") {
            filterObserveable.FirstExpression = "istrue";
            filterObserveable.Operator = "AND";
            filterObserveable.SecondExpression = undefined;
        } else if (me.type == "Custom") {
            filterObserveable.FirstCustom = values.firstValue;
            filterObserveable.SecondCustom = values.secondValue;
            filterObserveable.FirstCustomText = values.firstValue;
            filterObserveable.SecondCustomText = values.secondValue;
        }

        me.observable = z.observable(filterObserveable);
    },
    _parseValueFromComboBoxInputs: function (comboBox) {
        if (comboBox.selectedIndex == -1) {
            return undefined;
        }
        var value = comboBox.value();
        if (value == "-1") {
            return undefined;
        }
        return value === "" ? "null" : parseInt(value, 10);
    },
    _buildAndApplyFilterToGrid: function () {
        var me = this,
            firstInput,
            secondInput,
            field = me.field,
            fieldId,
            firstFieldId,
            secondFieldId,
            firstExpression = me.observable.FirstExpression,
            secondExpression = me.observable.SecondExpression,
            firstExpressionIsEQOrNE =
                firstExpression == "eq" || firstExpression == "neq",
            secondExpressionIsEQOrNE =
                secondExpression == "eq" || secondExpression == "neq";

        switch (me.type) {
            case "DateTime":
                firstInput =
                    me.observable.StartDateTime &&
                    me.observable.StartDateTime.toString();
                secondInput =
                    me.observable.EndDateTime &&
                    me.observable.EndDateTime.toString();
                break;
            case "Date":
                firstInput =
                    me.observable.StartDate &&
                    me.observable.StartDate.toString();
                secondInput =
                    me.observable.EndDate && me.observable.EndDate.toString();
                break;
            case "OffsetTime":
                firstInput =
                    me.observable.OffsetStartTime &&
                    me.observable.OffsetStartTime.toString();
                secondInput =
                    me.observable.OffsetEndTime &&
                    me.observable.OffsetEndTime.toString();
                break;
            case "TimeOfDay":
                firstInput =
                    me.observable.TimeOfDayStartTime &&
                    me.observable.TimeOfDayStartTime.toString();
                secondInput =
                    me.observable.TimeOfDayEndTime &&
                    me.observable.TimeOfDayEndTime.toString();
                break;
            case "Code":
                if (firstExpressionIsEQOrNE) {
                    firstInput = me._parseValueFromComboBoxInputs(
                        me.get("#FirstCode").data("kendoComboBox")
                    );
                    firstFieldId = me.codeId;
                } else if (me.observable.FirstCodeText) {
                    firstInput = me.observable.FirstCodeText;
                }

                if (secondExpressionIsEQOrNE) {
                    secondFieldId = me.codeId;
                    secondInput = me._parseValueFromComboBoxInputs(
                        me.get("#SecondCode").data("kendoComboBox")
                    );
                } else if (me.observable.SecondCodeText) {
                    secondInput = me.observable.SecondCodeText;
                }
                break;
            case "UDFEnum":
                firstInput = me._parseValueFromComboBoxInputs(
                    me.get("#FirstCode").data("kendoComboBox")
                );
                secondInput = me._parseValueFromComboBoxInputs(
                    me.get("#SecondCode").data("kendoComboBox")
                );
                fieldId = me.udfField;
                break;
            case "Int32":
            case "Int16":
            case "Byte":
            case "Currency":
            case "Decimal":
            case "Single":
                firstInput = me.observable.FirstNumber;
                secondInput = me.observable.SecondNumber;
                break;
            case "Custom":
                if (firstExpressionIsEQOrNE) {
                    firstInput =
                        (me.observable.FirstCustom &&
                            me.observable.FirstCustom.Value) ||
                        undefined;
                } else if (me.observable.FirstCustomText) {
                    firstInput = me.observable.FirstCustomText || undefined;
                }

                if (secondExpressionIsEQOrNE) {
                    secondInput =
                        (me.observable.SecondCustom &&
                            me.observable.SecondCustom.Value) ||
                        undefined;
                } else if (me.observable.SecondCustomText) {
                    secondInput = me.observable.SecondCustomText || undefined;
                }
                break;
        }

        var operator = me.observable.Operator,
            grid = $(`#${me.gridId}`).data("kendoGrid"),
            dataSource = grid.dataSource,
            existingFilter = me._getExistingGridFilter(
                dataSource,
                field,
                fieldId,
                firstFieldId,
                secondFieldId
            );

        $.each(grid.columns as any[], function (index, column) {
            if (column.field == me.field) {
                column.zFiltered = true;
                return false;
            }
        });

        var firstFilter = filter.empty();
        if (
            firstInput !== undefined ||
            firstExpression === "isnull" ||
            firstExpression === "isnotnull" ||
            firstExpression === "istrue" ||
            firstExpression === "isfalse"
        ) {
            firstFilter = me._buildFilterExpression(
                field,
                firstInput,
                firstExpression,
                firstFieldId || fieldId
            );
        }

        var secondFilter = filter.empty();
        if (
            secondInput !== undefined ||
            secondExpression === "isnull" ||
            secondExpression === "isnotnull" ||
            secondExpression === "istrue" ||
            secondExpression === "isfalse"
        ) {
            secondFilter = me._buildFilterExpression(
                field,
                secondInput,
                secondExpression,
                secondFieldId || fieldId
            );
        }

        var columnFilter = me._andOrFiltersTogether(
                firstFilter,
                secondFilter,
                operator
            ),
            combinedFilters = filter.all(existingFilter, columnFilter),
            kendoFilter = filter.toKendoFilter(combinedFilters);

        dataSource.filter(kendoFilter);

        $(`#${me.gridId}`).data("kendoGrid").trigger("filter");
        $(`#${me.gridId}`).data("me").options.kendoFilter = kendoFilter;
    },
    _presetDateRangeDataSource: function () {
        return [
            { Text: ll("ChooseDateRange"), Value: "" },
            { Text: ll("Today"), Value: "TODAY" },
            { Text: ll("Yesterday"), Value: "YESTERDAY" },
            { Text: ll("ThisWeek"), Value: "THIS_WEEK" },
            { Text: ll("ThisMonth"), Value: "THIS_MONTH" },
            { Text: ll("ThisYear"), Value: "THIS_YEAR" },
            { Text: ll("ThisQuarter"), Value: "THIS_QUARTER" },
            { Text: ll("LastWeek"), Value: "LAST_WEEK" },
            { Text: ll("LastMonth"), Value: "LAST_MONTH" },
            { Text: ll("LastYear"), Value: "LAST_YEAR" },
            { Text: ll("LastQuarter"), Value: "LAST_QUARTER" },
            { Text: ll("LastRollingWeek"), Value: "LAST_ROLLING_WEEK" },
            { Text: ll("LastRollingMonth"), Value: "LAST_ROLLING_MONTH" },
            { Text: ll("LastRollingYear"), Value: "LAST_ROLLING_YEAR" },
            { Text: ll("LastRollingQuarter"), Value: "LAST_ROLLING_QUARTER" }
        ];
    },
    _operatorDataSource: function () {
        return [
            { Text: ll("FilterableAnd"), Value: "AND" },
            { Text: ll("FilterableOr"), Value: "OR" }
        ];
    },
    _dateTimeDataSource: function () {
        const me = this;

        return [
            { Text: ll("FilterableDateGte"), Value: "gte" },
            { Text: ll("FilterableDateGt"), Value: "gt" },
            { Text: ll("FilterableDateEq"), Value: "eq" },
            { Text: ll("FilterableDateLt"), Value: "lt" },
            { Text: ll("FilterableDateLte"), Value: "lte" },
            ...(allowNullFilters(me.mainEntityType, me.field)
                ? [
                      { Text: ll("IsBlank"), Value: "isnull" },
                      { Text: ll("IsNotBlank"), Value: "isnotnull" }
                  ]
                : [])
        ];
    },
    _codeDataSource: function (isCode) {
        const me = this;

        return [
            { Text: ll("FilterableEq"), Value: "eq" },
            { Text: ll("FilterableNeq"), Value: "neq" },
            ...(isCode
                ? [
                      { Text: ll("FilterableStartswith"), Value: "startswith" },
                      { Text: ll("FilterableContains"), Value: "contains" },
                      {
                          Text: ll("FilterableDoesnotcontain"),
                          Value: "doesnotcontain"
                      },
                      { Text: ll("FilterableEndswith"), Value: "endswith" }
                  ]
                : []),
            ...(allowNullFilters(me.mainEntityType, me.field)
                ? [
                      { Text: ll("IsBlank"), Value: "isnull" },
                      { Text: ll("IsNotBlank"), Value: "isnotnull" }
                  ]
                : [])
        ];
    },
    _numericDataSource: function () {
        const me = this;
        return [
            { Text: ll("FilterableGte"), Value: "gte" },
            { Text: ll("FilterableGt"), Value: "gt" },
            { Text: ll("FilterableEq"), Value: "eq" },
            { Text: ll("FilterableLt"), Value: "lt" },
            { Text: ll("FilterableLte"), Value: "lte" },
            ...(allowNullFilters(me.mainEntityType, me.field)
                ? [
                      { Text: ll("IsBlank"), Value: "isnull" },
                      { Text: ll("IsNotBlank"), Value: "isnotnull" }
                  ]
                : [])
        ];
    },
    _booleanDataSource: function () {
        return [
            { Text: ll("IsTrue"), Value: "istrue" },
            { Text: ll("IsFalse"), Value: "isfalse" }
        ];
    },
    _customDataSource: function () {
        return [
            { Text: ll("FilterableEq"), Value: "eq" },
            { Text: ll("FilterableNeq"), Value: "neq" },
            { Text: ll("FilterableStartswith"), Value: "startswith" },
            { Text: ll("FilterableContains"), Value: "contains" },
            { Text: ll("FilterableDoesnotcontain"), Value: "doesnotcontain" },
            { Text: ll("FilterableEndswith"), Value: "endswith" }
        ];
    },
    _buildFilterExpression: function (field, value, operator, fieldId) {
        var filterExp = filter.empty();

        if (typeof value == "number" && fieldId) {
            field = fieldId.replaceAll("/", ".") || field;
        }

        switch (operator) {
            case "gte":
                filterExp = filterExp.andGreaterThanOrEqual(field, value);
                break;
            case "gt":
                filterExp = filterExp.andGreaterThan(field, value);
                break;
            case "eq":
                filterExp = filterExp.andEquals(field, value);
                break;
            case "neq":
                filterExp = filterExp.andDoesNotEqual(field, value);
                break;
            case "lt":
                filterExp = filterExp.andLessThan(field, value);
                break;
            case "lte":
                filterExp = filterExp.andLessThanOrEqual(field, value);
                break;
            case "startswith":
                filterExp = filterExp.andStartsWith(field, value);
                break;
            case "contains":
                filterExp = filterExp.andContains(field, value);
                break;
            case "doesnotcontain":
                filterExp = filterExp.andDoesNotContain(field, value);
                break;
            case "endswith":
                filterExp = filterExp.andEndsWith(field, value);
                break;
            case "isnull":
                filterExp = filterExp.andIsNull(field);
                break;
            case "isnotnull":
                filterExp = filterExp.andIsNotNull(field);
                break;
            case "istrue":
                filterExp = filterExp.andIsTrue(field);
                break;
            case "isfalse":
                filterExp = filterExp.andIsNotTrue(field);
                break;
        }

        return filterExp;
    },
    _andOrFiltersTogether: function (filter1, filter2, operator) {
        var filterExp = filter.empty();

        if (filter1.isEmptyFilter && filter2.isEmptyFilter) {
            return filterExp;
        }

        switch (operator) {
            case "AND":
                filterExp = filter.all(filter1, filter2);
                break;
            case "OR":
                filterExp = filter.any(filter1, filter2);
                break;
        }

        return filterExp;
    },
    _getExistingGridFilter: function (
        dataSource,
        field,
        fieldId,
        firstFieldId,
        secondFieldId
    ) {
        var me = this,
            existingFilter = dataSource.filter();

        if (existingFilter) {
            if (field) {
                existingFilter = me._eraseFiltersByField(field, existingFilter);
            }
            if (fieldId) {
                existingFilter = me._eraseFiltersByField(
                    fieldId,
                    existingFilter
                );
            }
            if (firstFieldId) {
                existingFilter = me._eraseFiltersByField(
                    firstFieldId,
                    existingFilter
                );
            }
            if (secondFieldId) {
                existingFilter = me._eraseFiltersByField(
                    secondFieldId,
                    existingFilter
                );
            }
            return filter.createFromKendoFilter(existingFilter);
        }

        return filter.empty();
    },
    _eraseFiltersByField: function (field, filterExp) {
        var me = this;

        field = field.replaceAll("/", ".");

        for (var i = 0; i < filterExp.filters.length; i++) {
            if (filterExp.filters[i].hasOwnProperty("filters")) {
                filterExp.filters[i] = me._eraseFiltersByField(
                    field,
                    filterExp.filters[i]
                );
                let currentFilter = filterExp.filters[i];

                if (
                    $.isEmptyObject(currentFilter) ||
                    (currentFilter.filters && currentFilter.filters.length == 0)
                ) {
                    filterExp.filters.splice(i, 1);
                    i--;
                    continue;
                }
            }

            if (filterExp.filters[i].hasOwnProperty("field")) {
                if (field == filterExp.filters[i].field) {
                    filterExp.filters.splice(i, 1);
                    i--;
                    continue;
                }
            }
        }

        return filterExp;
    },
    _getFiltersByField: function (field, filterExp) {
        var values, filter1, filter2;
        var fixFilterForNullFilters = (f: any) => {
            let operator = f.operator;
            let value = f.value;

            if (operator === "eq" && value === null) {
                operator = "isnull";
                value = undefined;
            }

            if (operator === "neq" && value === null) {
                (operator = "isnotnull"), (value = undefined);
            }

            return {
                field: f.field,
                operator,
                value
            };
        };

        field = field.replaceAll("/", ".");

        if (filterExp && filterExp.hasOwnProperty("filters")) {
            _.each(filterExp.filters, f => {
                if (f.field == field) {
                    filter1 = fixFilterForNullFilters(f);
                    values = {
                        firstExpression: filter1.operator || "eq",
                        firstValue: filter1.value,
                        operator: "AND",
                        secondExpression: "eq",
                        secondValue: undefined
                    };
                    return false;
                } else if (
                    f.logic == "and" &&
                    f.hasOwnProperty("filters") &&
                    f.filters[0].field == field
                ) {
                    filter1 = f.filters[0];
                    filter2 = f.filters[1] || {};

                    if (filter2.hasOwnProperty("filters")) {
                        filter2 = filter2.filters[0];
                    }

                    filter1 = fixFilterForNullFilters(filter1);
                    filter2 = fixFilterForNullFilters(filter2);

                    values = {
                        firstExpression: filter1.operator || "eq",
                        firstValue: filter1.value,
                        operator: "AND",
                        secondExpression: filter2.operator || "eq",
                        secondValue: filter2.value || undefined
                    };
                    return false;
                } else if (
                    f.logic == "or" &&
                    f.hasOwnProperty("filters") &&
                    f.filters[0].hasOwnProperty("filters") &&
                    f.filters[0].filters[0].field == field
                ) {
                    filter1 = f.filters[0];
                    filter2 = f.filters[1] || {};

                    if (filter1.hasOwnProperty("filters")) {
                        filter1 = filter1.filters[0];
                    }

                    if (filter2.hasOwnProperty("filters")) {
                        filter2 = filter2.filters[0];
                    }

                    filter1 = fixFilterForNullFilters(filter1);
                    filter2 = fixFilterForNullFilters(filter2);

                    values = {
                        firstExpression: filter1.operator || "eq",
                        firstValue: filter1.value,
                        operator: "OR",
                        secondExpression: filter2.operator || "eq",
                        secondValue: filter2.value || undefined
                    };
                    return false;
                }
            });
        }

        if (!values) {
            values = {
                firstExpression: "eq",
                firstValue: undefined,
                operator: "AND",
                secondExpression: "eq",
                secondValue: undefined
            };
        }

        return values;
    },
    _resetGridFilters: function () {
        var me = this,
            dataSource = $(`#${me.gridId}`).data("kendoGrid").dataSource,
            existingFilter = dataSource.filter();

        $.each(
            $(`#${me.gridId}`).data("kendoGrid").columns as any[],
            function (index, column) {
                if (column.field == me.field) {
                    column.zFiltered = false;
                    return false;
                }
            }
        );

        if (existingFilter) {
            var filterExp = {};
            if (me.type == "Code") {
                filterExp = me._eraseFiltersByField(me.codeId, existingFilter);
                filterExp = me._eraseFiltersByField(me.field, filterExp);
            } else if (me.type == "UDFEnum") {
                filterExp = me._eraseFiltersByField(
                    me.udfField,
                    existingFilter
                );
            } else {
                filterExp = me._eraseFiltersByField(me.field, existingFilter);
            }
            dataSource.filter(filterExp);
        } else {
            dataSource.filter({});
        }
        $(`#${me.gridId}`).data("kendoGrid").trigger("filter");
    },
    _setComboBoxInitialDataSources: function () {
        var me = this,
            firstExpression = me
                .get("#FirstExpression")
                .data("kendoDropDownList"),
            secondExpression = me
                .get("#SecondExpression")
                .data("kendoDropDownList"),
            firstCodeText = me.get("#FirstCodeText"),
            secondCodeText = me.get("#SecondCodeText"),
            firstCustomText = me.get("#FirstCustomText"),
            secondCustomText = me.get("#SecondCustomText");

        firstCodeText.closest(".pane-field").hide();
        secondCodeText.closest(".pane-field").hide();
        firstCustomText.closest(".pane-field").hide();
        secondCustomText.closest(".pane-field").hide();

        var setCodeDataSource = function (isCode?) {
            firstExpression.setDataSource(me._codeDataSource(isCode));
            firstExpression.select(0);
            secondExpression.setDataSource(me._codeDataSource(isCode));
            secondExpression.select(0);

            if (isCode) {
                firstExpression.bind("change", function () {
                    var val = this.value();

                    switch (val) {
                        case "eq":
                        case "neq":
                            me.get("#FirstCode").closest(".pane-field").show();
                            firstCodeText.closest(".pane-field").hide();
                            firstCodeText.val("");
                            me.get("#FirstCode")
                                .data("kendoComboBox")
                                .select(-1);
                            break;
                        case "startswith":
                        case "contains":
                        case "doesnotcontain":
                        case "endswith":
                            me.get("#FirstCode").closest(".pane-field").hide();
                            firstCodeText.closest(".pane-field").show();
                            me.get("#FirstCode")
                                .data("kendoComboBox")
                                .select(-1);
                            me.observable.set("FirstCodeText", undefined);
                            break;
                    }
                });

                secondExpression.bind("change", function () {
                    var val = this.value();

                    switch (val) {
                        case "eq":
                        case "neq":
                            me.get("#SecondCode").closest(".pane-field").show();
                            secondCodeText.closest(".pane-field").hide();
                            secondCodeText.val("");
                            me.get("#SecondCode")
                                .data("kendoComboBox")
                                .select(-1);
                            break;
                        case "startswith":
                        case "contains":
                        case "doesnotcontain":
                        case "endswith":
                            me.get("#SecondCode").closest(".pane-field").hide();
                            secondCodeText.closest(".pane-field").show();
                            me.get("#SecondCode")
                                .data("kendoComboBox")
                                .select(-1);
                            me.observable.set("SecondCodeText", undefined);
                            break;
                    }
                });
            }
        };

        var setCustomDataSource = function () {
            firstExpression.setDataSource(me._customDataSource());
            firstExpression.select(0);
            secondExpression.setDataSource(me._customDataSource());
            secondExpression.select(0);
            firstExpression.bind("change", function () {
                var val = this.value();

                switch (val) {
                    case "eq":
                    case "neq":
                        me.get("#FirstCustom").closest(".pane-field").show();
                        firstCustomText.closest(".pane-field").hide();
                        me.observable.set("FirstCustom", undefined);
                        me.observable.set("FirstCustomText", undefined);
                        break;
                    case "startswith":
                    case "contains":
                    case "doesnotcontain":
                    case "endswith":
                        me.get("#FirstCustom").closest(".pane-field").hide();
                        firstCustomText.closest(".pane-field").show();
                        me.observable.set("FirstCustom", undefined);
                        me.observable.set("FirstCustomText", undefined);
                        break;
                }
            });
            secondExpression.bind("change", function () {
                var val = this.value();

                switch (val) {
                    case "eq":
                    case "neq":
                        me.get("#SecondCustom").closest(".pane-field").show();
                        secondCustomText.closest(".pane-field").hide();
                        me.observable.set("SecondCustom", undefined);
                        me.observable.set("SecondCustomText", undefined);
                        break;
                    case "startswith":
                    case "contains":
                    case "doesnotcontain":
                    case "endswith":
                        me.get("#SecondCustom").closest(".pane-field").hide();
                        secondCustomText.closest(".pane-field").show();
                        me.observable.set("SecondCustom", undefined);
                        me.observable.set("SecondCustomText", undefined);
                        break;
                }
            });
        };

        switch (me.type) {
            case "Code":
                var typeIsCode = true;
                me._checkCodeAndChangeDataTextFieldIfNeeded();
                me.get("#FirstCode")
                    .data("kendoComboBox")
                    .setDataSource(codes[me.code]);
                me.get("#SecondCode")
                    .data("kendoComboBox")
                    .setDataSource(codes[me.code]);
                setCodeDataSource(typeIsCode);
                break;
            case "UDFEnum":
                me.get("#FirstCode")
                    .data("kendoComboBox")
                    .setDataSource(me.userDefinedList);
                me.get("#SecondCode")
                    .data("kendoComboBox")
                    .setDataSource(me.userDefinedList);
                setCodeDataSource();
                break;
            case "DateTime":
                me.get("#PresetDateRanges")
                    .data("kendoDropDownList")
                    .setDataSource(me._presetDateRangeDataSource());
                me.get("#PresetDateRanges").data("kendoDropDownList").select(0);
                firstExpression.setDataSource(me._dateTimeDataSource());
                secondExpression.setDataSource(me._dateTimeDataSource());
                break;
            case "Date":
                me.get("#PresetDateRanges")
                    .data("kendoDropDownList")
                    .setDataSource(me._presetDateRangeDataSource());
                me.get("#PresetDateRanges").data("kendoDropDownList").select(0);
                firstExpression.setDataSource(me._dateTimeDataSource());
                secondExpression.setDataSource(me._dateTimeDataSource());
                break;
            case "OffsetTime":
            case "TimeOfDay":
                firstExpression.setDataSource(me._dateTimeDataSource());
                firstExpression.select(1);
                secondExpression.setDataSource(me._dateTimeDataSource());
                secondExpression.select(3);
                break;
            case "Int32":
            case "Int16":
            case "Byte":
            case "Currency":
            case "Decimal":
            case "Single":
                firstExpression.setDataSource(me._numericDataSource());
                secondExpression.setDataSource(me._numericDataSource());
                break;
            case "Boolean":
                firstExpression.setDataSource(me._booleanDataSource());
                break;
            case "Custom":
                me.get("#FirstCustom").data("kendoComboBox").setOptions({
                    headerTemplate: me.customFilterMenu.headerTemplate,
                    template: me.customFilterMenu.template
                });
                me.get("#SecondCustom").data("kendoComboBox").setOptions({
                    headerTemplate: me.customFilterMenu.headerTemplate,
                    template: me.customFilterMenu.template
                });
                me.get("#FirstCustom")
                    .data("kendoComboBox")
                    .list.width(me.customFilterMenu.width);
                me.get("#SecondCustom")
                    .data("kendoComboBox")
                    .list.width(me.customFilterMenu.width);
                me.get("#FirstCustom")
                    .data("kendoComboBox")
                    .setDataSource(me.customFilterMenu.dataSource);
                me.get("#SecondCustom")
                    .data("kendoComboBox")
                    .setDataSource(me.customFilterMenu.dataSource);
                setCustomDataSource();
                break;
        }

        if (me.type !== "Boolean") {
            var operator = me.get("#Operator").data("kendoDropDownList");
            operator.setDataSource(me._operatorDataSource());
            operator.select(0);
        }
    },
    _checkCodeAndChangeDataTextFieldIfNeeded: function () {
        var me = this;

        // Most of z.codes has a property "CodeNumber" and "Value", however,
        // some do not like Division and Region. They have "DivisionName" and
        // "DivisionNumber", so look in the schema for their primary and secondary
        // fields and display those.

        var fieldResults = schema.getCodeDisplayFields({ entityName: me.code });
        if (
            fieldResults.primaryField == "CodeNumber" &&
            fieldResults.secondaryField == "Value"
        ) {
            return;
        }

        var codeNumber = fieldResults.primaryField,
            codeName = fieldResults.secondaryField,
            dataTextField = codeNumber == me.field ? codeNumber : codeName,
            template =
                '<span name="#= data.{0} #" class="k-state-default k-dropdown-option #: (data.Deleted || data.IsDeleted) ? "deleted" : "" #">' +
                '<span class="code-dropdown">#: data.{0} #</span><span class="code-dropdown">#: data.{1} #</span></span>';
        template = template.format(codeNumber, codeName);

        me.get("#FirstCode").data("kendoComboBox").setOptions({
            dataTextField: dataTextField,
            template: template
        });
        me.get("#SecondCode").data("kendoComboBox").setOptions({
            dataTextField: dataTextField,
            template: template
        });
    },
    _closeFilterMenu: function () {
        var me = this;
        me.closeMenu = true;
        me.menu.close($(`#${me.formId}`).closest('[role="menuitem"]'));
    },
    _getUserDefinedListId: function (codeSelectPath) {
        let key = codeSelectPath,
            lastIndexOfSlash = key.lastIndexOf("/");

        if (lastIndexOfSlash > -1) {
            const lengthOfSlash = 1,
                startingIndex = lastIndexOfSlash + lengthOfSlash;
            key = key.substring(startingIndex);
        }

        let userDefinedField =
            _.find(user.companyData.UserDefinedFields, function (udf) {
                return udf && udf.BindName == key;
            }) || ({} as UserDefinedField);

        return userDefinedField.UserDefinedListId;
    },
    _isTypeSupported: function () {
        const me = this;

        return (
            me.type === "DateTime" ||
            me.type === "Date" ||
            me.type === "TimeOfDay" ||
            me.type === "OffsetTime" ||
            me.type === "Code" ||
            me.type === "UDFEnum" ||
            me.type === "Int32" ||
            me.type === "Int16" ||
            me.type === "Byte" ||
            me.type === "Currency" ||
            me.type === "Decimal" ||
            me.type === "Single" ||
            me.type === "Boolean" ||
            me.type === "Custom"
        );
    }
};

export function fixGridFilterMenuForChrome(menu) {
    // Workaround for issue described at: http://www.telerik.com/forums/issue-with-grid-filter-(on-chrome-55-0-2883-75)
    menu.bind("activate", function (e) {
        var applyFilterActivated = e.item.is(":last-child");
        if (applyFilterActivated) {
            e.item.find("span.k-dropdown.k-header").first().focus();
            e.item.find("button").last().focus();
        }
    });
}
